import axios from "axios";
const API_URL = "/api/v1";
export const TMS_URL = API_URL+"/tms/my_tms/";


export function getTmsData(data) {
  return axios.post(TMS_URL, data);
}
